<template>
  <a-card :title="title">
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col span="12">
          <a-form-model-item label="发布平台" prop="line_id">
            <a-select
              v-model="form.line_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择发布平台"
            >
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">
                {{ item.org }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="平台分类" prop="platform_class">
            <a-select
              v-model="form.platform_class"
              @change="platformChange"
              show-search
              option-filter-prop="children"
              placeholder="请选择平台分类"
            >
              <a-select-option v-for="item in PICTURES_PLATFORM_CLASS" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="类型" prop="class">
            <a-select
              v-model="form.class"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择类型"
            >
              <a-select-option v-for="item in PICTURES_CLASS_TYPE" :key="item.key" :value="item.key">{{
                item.value
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="标识" prop="slug">
            <a-input v-model.trim="form.slug" allowClear placeholder="辅助定位图片位置，不超过50字" :maxLength="50" />
          </a-form-model-item>
        </a-col>

        <a-col span="11" offset="1">
          <a-row span="12">
            <a-col span="8">
              <a-form-model-item label="图片" prop="path">
                <a-upload
                  :accept="imageAccept"
                  list-type="picture-card"
                  :headers="{ token }"
                  :file-list="path_list"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :remove="() => handleRemove('path')"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'path')"
                  @preview="handlePreview"
                  @change="(data) => handleChange('path', data)"
                >
                  <div v-if="path_list.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-form-model-item>
              <span style="width: 300px; position: absolute; top: 105px; left: 50px"
              >支持上传jpg、png、gif等图片格式，不超过5M</span
              >
            </a-col>
            <a-col span="8">
              <a-form-model-item label="左副图" label-width="120px">
                <a-upload
                  :accept="imageAccept"
                  list-type="picture-card"
                  :headers="{ token }"
                  :file-list="copy_left_top_list"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :remove="() => handleRemove('copy_left_top', 0)"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'copy_left_top')"
                  @preview="handlePreview"
                  @change="(data) => handleChange('copy_left_top', data, 0)"
                >
                  <div v-if="copy_left_top_list.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-form-model-item>
            </a-col>
            <a-col span="8">
              <a-form-model-item label="右副图" label-width="120px">
                <a-upload
                  :accept="imageAccept"
                  list-type="picture-card"
                  :headers="{ token }"
                  :file-list="copy_right_bottom_list"
                  :action="`${baseURL}/public/upload-file-qi-niu`"
                  :remove="() => handleRemove('copy_left_top', 1)"
                  :beforeUpload="(file) => handleBeforeUpload(file, 'copy_right_bottom')"
                  @preview="handlePreview"
                  @change="(data) => handleChange('copy_right_bottom', data, 1)"
                >
                  <div v-if="copy_right_bottom_list.length < 1">
                    <a-icon type="plus" />
                    <div class="ant-upload-text">Upload</div>
                  </div>
                </a-upload>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="跳转地址" prop="link_url">
            <a-input v-model.trim="form.link_url" allowClear placeholder="请输入跳转地址,不超过200字" />
          </a-form-model-item>
          <a-checkbox :checked="checkedTarget" @change="changeTarget" class="checkedtarget"> 是否新开窗口 </a-checkbox>
          <a-checkbox :checked="isHideButton" @change="changeHideButton" class="checkedhide"> 是否隐藏按钮 </a-checkbox>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="ALT">
            <a-input
              v-model.trim="form.alt"
              allowClear
              placeholder="图片不能正常显示时，显示的默认文字，不超过50字"
              :maxLength="50"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="排序" prop="sort">
            <a-input-number v-model="form.sort" placeholder="请输入排序值，0~100的整数" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="雪碧图设置" prop="sprite_setting">
            <a-row :gutter="12" class="pic-config">
              <a-col :span="12">
                <div class="config-item">
                  <div class="label">宽：</div>
                  <a-input-number
                    v-model="form.sprite_setting.width"
                    size="small"
                    :min="0"
                    :precision="1"
                    placeholder="请输入宽"
                    style="width: 100%"
                  />
                  <div class="unit">px</div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="config-item">
                  <div class="label">高：</div>
                  <a-input-number
                    v-model="form.sprite_setting.height"
                    size="small"
                    :min="0"
                    :precision="1"
                    placeholder="请输入高"
                    style="width: 100%"
                  />
                  <div class="unit">px</div>
                </div>
              </a-col>
              <a-col :span="24">
                <div class="config-item">
                  <div class="label">雪碧图张数：</div>
                  <a-input-number
                    v-model="form.sprite_setting.size"
                    size="small"
                    :min="0"
                    :precision="0"
                    placeholder="请输入"
                    style="width: 100%"
                  />
                </div>
              </a-col>
              <a-col :span="12">
                <div class="config-item">
                  <div class="label">播放速度：</div>
                  <a-input-number
                    v-model="form.sprite_setting.speed"
                    size="small"
                    :min="0.001"
                    :precision="3"
                    placeholder="请输入秒"
                    style="width: 100%"
                  />
                  <div class="unit">S</div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="config-item">
                  <div class="label">方向：</div>
                  <a-select v-model="form.sprite_setting.direction" size="small" allowClear style="width: 100%">
                    <a-select-option :value="1">横向</a-select-option>
                    <a-select-option :value="2">纵向</a-select-option>
                  </a-select>
                </div>
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="开始时间" prop="start_at">
            <v-date-picker
              v-model="form.start_at"
              allowClear
              placeholder="请选择开始时间"
              style="width: 100%"
              show-time
              :defaultPickerValue="moment('00:00:00', 'HH:mm:ss')"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="结束时间" prop="end_at">
            <v-date-picker
              v-model="form.end_at"
              show-time
              allowClear
              placeholder="请选择结束时间"
              style="width: 100%"
              :defaultPickerValue="moment('23:59:59', 'HH:mm:ss')"
            />
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="状态">
            <a-radio-group v-model="form.state" name="radioGroup">
              <a-radio v-for="item in PICTURES_STATE" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col span="12">
          <a-form-model-item label="示例">
            <a-upload
              :accept="imageAccept"
              :headers="{ token }"
              :file-list="defaultFileList"
              :remove="handleRemoveDemo"
              :customRequest="beforeUploadDemo"
              @preview="handlePreview"
            >
              <div v-if="defaultFileList.length < 1">
                <a-button type="primary">点击上传</a-button>
                <span> 仅支持上传jpg、png、gif，不超过5M</span>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item label="示例说明">
            <a-textarea
              :maxLength="200"
              :rows="3"
              v-model="form.literal_explan"
              allowClear
              placeholder="请输入备注，不超过200字"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :wrapper-col="{ span: 20, offset: 1 }">
            <a-button :loading="submitLoading" class="mr20" type="primary" v-preventReClick @click="handleSubmit"
            >保 存</a-button
            >
            <a-button @click="$router.go('-1')">取 消</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <!-- 图片预览 -->
    <a-modal width="40%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-card>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance, computed } from '@vue/composition-api'
import uploadImg from './composables/uploadImg'
import { form, rules } from './business/form'
import token from '@/composables/token'
import compuedFun from './computed/'
import moment from 'moment'
import { OSSClient } from './composables/oss'
import { cloneDeep } from 'lodash'
import api from '@/api/'

const title = {
  Add: '添加图片',
  Edit: '编辑图片',
}

export default {
  name: 'PicDetails',
  setup(props, { root }) {
    const _this = getCurrentInstance()

    const state = reactive({
      rules,
      form: JSON.parse(JSON.stringify(form)),
      title: _this.$route.params.id ? title.Edit : title.Add,
      id: _this.$route.params.id, // 图片id
      baseURL: process.env.VUE_APP_API_BASE_URL,
      platformList: [], // 平台类型
      submitLoading: false,
      imageAccept: '.gif, .jpg, .jpeg, .png',
      defaultFileList: [],
      checkedTarget: true,
      isHideButton: true,
      moment,
    })

    onMounted(() => {
      methods.getPlatform()
      if (state.id) methods.getPictureDetail()
    })

    const methods = {
      platformChange(value) {
        if (value !== 4) {
          state.form.picture_type = 0
        }
      },
      async getPictureDetail() {
        const res = await api.detailPicture({ id: state.id })
        const data = cloneDeep(res?.data?.pictures)
        const sprite_setting = {
          width: undefined,
          height: undefined,
          size: undefined,
          speed: undefined,
          direction: undefined,
        }
        state.form = { ...state.form, ...data }
        state.checkedTarget = state.form.target === '_blank'
        state.isHideButton = Number(state.form.hide_button) === 1
        state.form.sprite_setting = state.form?.sprite_setting || sprite_setting
        _this.handleEchoImg(data)
      },
      async postPicture() {
        const data = JSON.parse(JSON.stringify(state.form))
        let res = null
        this.submitLoading = true
        if (state.id) {
          res = await api.updatePicture(data)
        } else {
          res = await api.AddPicture(data)
        }
        this.submitLoading = false
        if (_this.$validate(res)) {
          _this.$message.success(state.id ? '编辑成功~' : '新增成功~')
          _this.$router.push('/picture/list')
        }
      },
      // 提交
      async handleSubmit() {
        _this.$refs.formDom.validate(async (valid) => {
          if (valid) {
            const data = JSON.parse(JSON.stringify(state.form))
            delete data.check_repeat
            if (data.start_at >= data.end_at) {
              _this.$message.warning('结束时间不能小于等于开始时间！')
              return
            }
            const res = await api.repeatCheck(data)
            if (res.code !== '000000') return
            if (res.data === true) {
              _this.postPicture()
              return
            }
            _this.$confirm({
              title: res.data.msg,
              okText: '确定并继续提交',
              cancelText: '取消',
              onOk() {
                _this.postPicture()
              },
              onCancel() {},
            })
          } else {
            _this.$message.warning('请检查信息是否填写完成')
          }
        })
      },
      getPlatform: async function () {
        const res = await api.LineListNew()
        state.platformList = res.data
      },
      changeTarget(e) {
        state.form.target = e.target.checked ? '_blank' : '_self'
        state.checkedTarget = e.target.checked
      },
      changeHideButton(e) {
        state.form.hide_button = e.target.checked ? 1 : 2
        state.isHideButton = e.target.checked
      },
      handleRemoveDemo() {
        state.defaultFileList = []
        state.form.demo_picture = ''
      },
      async handleUpload(file, fileName, client) {
        try {
          const _this = this
          // 分片上传
          const res = await client.multipartUpload(fileName, file, {
            progress: async function (p) {
              _this.videoUploadPercent = Number((p * 100).toFixed(0))
            },
          })
          const url = res.res.requestUrls[0].split('?')[0]
          return { url: url, name: fileName }
        } catch (err) {
          this.$message.error(`${fileName}上传失败`)
        }
      },
      async beforeUploadDemo(file) {
        const fileTypes = ['image/', 'image/jpg', 'image/png', 'image/jpeg', 'image/gif']
        if (!fileTypes.includes(file.file.type)) {
          this.$message.error('图片格式只能为jpg, jpeg, png, gif')
          return false
        }
        if (file.file.size > 5 * 1024 * 1024) {
          this.$message.error('请上传小于5M的文件！')
          return false
        }
        if (file.file.type !== 'application/pdf') {
          // this.demoloading = true
          const client = await OSSClient()
          const uploadPath = `${client.options.dir}/${new Date().getTime()}_${file.file.name}`
          await this.handleUpload(file.file, uploadPath, client).then((res) => {
            if (res) {
              file.file.url = res.url
              state.defaultFileList.push(file.file)
              state.form.demo_picture = res.url
              // this.form.pdf_title = file.file.name
              // this.demoloading = false
            }
          })
        } else {
          // this.pdfloading = false
          return false
        }
      },
    }

    return {
      ...toRefs(state),
      ...uploadImg(),
      ...compuedFun(),
      ...token(),
      ...methods,
    }
  },
}
</script>

<style lang="less" scoped>
.tailor-img {
  width: 100px;
  height: 100px;
}

.img-default {
  width: 100px;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pc-preview {
  background-color: orange;
  position: fixed;
  width: 100%;
  height: 100%;
}

::v-deep .ant-upload-picture-card-wrapper {
  width: auto;
}

::v-deep .ant-card-body {
  padding: 50px;
}
.checkedtarget,.checkedhide {
  height: 20px;
  display: flex;
  align-items: center;
  position: absolute;
  right: -50px;
  font-size: 12px;
  ::v-deep.ant-checkbox {
    margin-top: 2px;
  }
}
.checkedtarget {
  top: 0;
}
.checkedhide {
  bottom: 12px;
}
.pic-config {
  border: 1px dashed #ccc;
  padding: 10px;
  .config-item {
    display: flex;
    align-items: center;
    .label {
      white-space: nowrap;
    }
    .unit {
      padding: 0px 4px;
    }
  }
}
/deep/.ant-form-item {
  margin-bottom: 12px;
}
</style>
